var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrophyEmoji(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.41538 3.33331H7.41538C8.15138 3.33331 8.66672 3.26398 8.66672 3.99998V2.66665C8.66672 1.93065 8.15138 1.33331 7.41538 1.33331H2.08205C0.748718 1.33331 -0.306616 2.74998 0.082051 4.66665C0.082051 4.66665 1.27605 10.9166 1.36005 11.3053C1.58205 12.3333 2.77605 13.3333 4.05405 13.3333H8.69272C9.42938 13.3333 8.66672 12.0693 8.66672 11.3333V9.99998C8.66672 10.736 8.15138 11.3333 7.41538 11.3333H4.74872C4.01272 11.3333 3.52672 10.6386 3.41538 9.99998C3.30405 9.36131 2.35938 5.11131 2.35938 5.11131C2.13738 3.83331 2.67872 3.33331 3.41538 3.33331ZM20.6234 3.33331H16.6234C15.8874 3.33331 14.6667 3.26398 14.6667 3.99998V2.66665C14.6667 1.93065 15.8874 1.33331 16.6234 1.33331H21.9567C23.2901 1.33331 24.3461 2.74998 23.9567 4.66665C23.9567 4.66665 22.8681 10.946 22.7761 11.3333C22.5401 12.3333 21.4147 13.3333 20.1094 13.3333H15.3454C14.6094 13.3333 14.6667 12.0693 14.6667 11.3333V9.99998C14.6667 10.736 15.8874 11.3333 16.6234 11.3333H19.2901C20.0261 11.3333 20.5127 10.6386 20.6234 9.99998C20.7341 9.36131 21.6794 5.11131 21.6794 5.11131C21.9007 3.83331 21.3601 3.33331 20.6234 3.33331ZM13.8881 14.6666C13.8881 10.028 12.0821 14.6666 12.0821 14.6666C12.0821 14.6666 10.0821 10.028 10.0821 14.6666C10.0821 19.3053 7.88805 21.3333 7.88805 21.3333H16.0827C16.0821 21.3333 13.8881 19.3053 13.8881 14.6666Z",
    fill: "#FFAC33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4162 4.38465C19.4162 8.90132 14.9028 16.5127 12.0828 16.5127C9.26218 16.5127 4.74951 8.90132 4.74951 4.38465C4.74951 0.921321 5.41618 0.171988 6.74951 0.171988C7.66551 0.171988 10.7662 0.153988 12.0828 0.153988L16.7495 0.153321C18.6942 0.152654 19.4162 0.609321 19.4162 4.38465Z",
    fill: "#FFCC4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 22C18 22.736 18.1513 23.3333 17.4153 23.3333H6.74867C6.012 23.3333 6 22.736 6 22V21.3333C6 20.5973 6.776 20 7.47067 20H16.7487C17.4433 20 18 20.5973 18 21.3333V22Z",
    fill: "#C1694F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3332 23.0833C19.3332 23.59 19.4432 24 18.4985 24H5.66517C4.80384 24 4.6665 23.59 4.6665 23.0833V22.9167C4.6665 22.41 5.1585 22 5.66517 22H18.4985C19.0045 22 19.3332 22.41 19.3332 22.9167V23.0833Z",
    fill: "#C1694F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophyEmoji);
export default __webpack_public_path__ + "static/media/trophy-emoji.1563ab764227e8cd35edb35fb7bae5f5.svg";
export { ForwardRef as ReactComponent };